<a
  *transloco="let t; read: 'social-share-buttons'"
  id="trkTwitterShareButton"
  class="btn-share btn-share-twitter"
  href="javascript:void(0)"
  [attr.aria-label]="t('x_share')"
  (click)="share()">
  <accredible-icon [icon]="'x'"> </accredible-icon>
</a>
